import { createApp } from '@backstage/frontend-defaults';
import { apisModule } from './modules/apis';
import { gitlabAuthModule } from './modules/gitlab-auth';
import { cicdStatisticsModule } from './modules/cicd-statistics';
import { gitlabPipelinesApiModule } from './modules/gitlab-pipelines';
import { homeModule } from './modules/home';
import { iconsModule } from './modules/icons';
import { navModule } from './modules/nav';
import { notificationSettingsModule } from './modules/notification-settings';
import { signInModule } from './modules/sign-in';

export default createApp({
  features: [
    apisModule,
    gitlabAuthModule,
    iconsModule,
    navModule,
    signInModule,
    gitlabPipelinesApiModule,
    cicdStatisticsModule,
    notificationSettingsModule,
    homeModule,
  ],
});
